import StarIcon from '@assets/media/filled-rating.png';
import Icon from 'common/components/Icon';
import { QualityIcon } from 'common/components/quality-icon';
import { Epg } from 'common/constants/data-types';
import { isEmpty } from 'lodash';
import React, { useCallback, useMemo } from 'react';
import MetadataCategory from './MetadataCategory';
import MetadataSeparator from './MetadataSeparator';
export interface MetadataStripProps {
  year?: Epg['year'];
  country?: Epg['country'];
  major_category?: Epg['major_category'];
  minor_categories?: Epg['minor_categories'];
  duration?: Epg['duration'];
  rating?: Epg['rating'];
  resolution?: string;
}

function MetadataStrip(props: MetadataStripProps) {
  const renderRating = useCallback(() => {
    if (!props.rating) {
      return undefined;
    }
    const rating = props.rating.Overall || props.rating.OverallMP;
    if (!rating) {
      return undefined;
    }
    return (
      <span className="metadata-rating" key="metadata-rating" data-test-id="metadata-rating">
        <Icon size="verySmall" src={StarIcon} />
        <span>{rating}</span>
        <span className="metadata-rating-max">/10</span>
      </span>
    );
  }, [props.rating]);

  const renderCountries = useCallback(() => {
    if (!props.country) {
      return undefined;
    }
    return (
      <React.Fragment key="metadata-countries">
        {props.year && <MetadataSeparator />}
        <span data-test-id="metadata-countries">{props.country[0]}</span>
      </React.Fragment>
    );
  }, [props.country]);

  const renderYear = useCallback(() => {
    if (!props.year) {
      return;
    }
    return (
      <React.Fragment key="metadata-year">
        <span data-test-id="metadata-year">{props.year}</span>
      </React.Fragment>
    );
  }, [props.year]);

  const renderDuration = useCallback(() => {
    if (!props.duration) {
      return null;
    }
    const split = props.duration.split(':').map((e) => parseInt(e));
    const duration = `${split[0] ? `${split[0]}ч.` : ''}${split[1] ? ` ${split[1]}м.` : ''}`;
    return (
      <>
        <MetadataSeparator />
        <span
          className="description-duration"
          key="metadata-duration"
          data-test-id="metadata-duration"
        >
          {duration}
        </span>
      </>
    );
  }, [props.duration]);

  const resolution = useMemo(() => {
    if (isEmpty(props.resolution) || !props.resolution) {
      return undefined;
    }
    return parseInt(props.resolution.split('x')[1]);
  }, [props.resolution]);

  return (
    <div className="description-row-container">
      {renderYear()}
      {renderCountries()}
      <MetadataCategory
        major_category={props.major_category}
        minor_categories={props.minor_categories?.slice(0, 2) || []}
      />
      {renderDuration()}
      {resolution && <QualityIcon size="large" resolutionHeight={resolution} noMargin />}
      {renderRating()}
    </div>
  );
}
export default React.memo(MetadataStrip);
